<template>
  <main>
    <div class="container">
      <b-row>
        <b-col cols="4">
          <div class="top-block mb-4">
            <div class="top-block__title">
              <h2 class="top-block__title__text">
                Мой профиль
              </h2>
            </div>
          </div>
          <form
            class="profile-form"
            @submit.prevent="editUser"
          >
            email:
            <span id="login_place">
              {{ user.email }}
            </span>
            <hr />
            <b-form-group label="Имя на портале">
              <b-form-input
                id="name"
                v-model="name"
                :state="validation.name.state"
                autocomplete="username"
              />
              <b-form-invalid-feedback id="name-feedback">
                {{ validation.name.error }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mb-5"
              label="Рабочий телефон"
            >
              <the-mask
                id="phone"
                v-model="phone"
                mask="+7 (###) ###-##-##"
                masked
                class="form-control"
                placeholder="+7 (921) 123-45-67"
              />
            </b-form-group>
            <b-form-group label="Новый пароль">
              <b-form-input
                id="password"
                v-model="password"
                type="password"
                placeholder="********"
                :state="validation.password.state"
                autocomplete="new-password"
              >
              </b-form-input>
              <b-form-invalid-feedback id="password-feedback">
                {{ validation.password.error }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Подтвердите пароль">
              <b-form-input
                id="confirm-password"
                v-model="confirmPassword"
                type="password"
                placeholder="********"
                :state="validation.confirmPassword.state"
                aria-describedby="confirm-password-feedback"
                autocomplete="new-password"
              >
              </b-form-input>
              <b-form-invalid-feedback id="confirm-password-feedback">
                {{ validation.confirmPassword.error }}
              </b-form-invalid-feedback>
            </b-form-group>
            <password-rules></password-rules>
            <button
              class="btn btn-primary-ford-blue mt-5"
              :disabled="processing"
            >
              Сохранить изменения
            </button>
          </form>
        </b-col>
        <b-col
          cols="4"
          offset="1"
        >
          <template v-if="dealer">
            <div class="top-block mb-4">
              <div class="top-block__title">
                <h2 class="top-block__title__text">
                  Информация дилера
                </h2>
              </div>
            </div>
            <form
              class="profile-form"
              @submit.prevent="editDealer"
            >
              Дилер:
              <span id="login_place">
                {{ dealer.name }}
              </span>
              <hr />
              <b-form-group label="E-mail">
                <b-form-input v-model="dealer.email" />
              </b-form-group>
              <b-form-group
                class="mb-5"
                label="Телефон"
              >
                <input
                  v-model="dealer.phone"
                  type="phone"
                  class="form-control"
                  placeholder="8 (921) 123-45-67"
                />
              </b-form-group>
              <button
                class="btn btn-primary-ford-blue mt-5"
                :disabled="processing"
              >
                Сохранить изменения
              </button>
            </form>
          </template>
          <template v-if="URCode && !dealer">
            <div
              key="loader"
              class="table-state-block__preloader spinner-fade-in"
            >
              <div class="spinner-border"></div>
            </div>
          </template>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import ErrorProcessing from '@/mixins/ErrorProcessing';
import PasswordRules from '@/components/users/PasswordRules';

export default {
  name: 'Profile',
  components: {
    PasswordRules,
  },
  mixins: [ErrorProcessing],
  data: () => ({
    name: '',
    phone: '',
    password: '',
    confirmPassword: '',
    validation: {
      name: { error: '', state: null },
      phone: { error: '', state: null },
      password: { error: '', state: null },
      confirmPassword: { error: '', state: null },
    },
    URCode: null,
    processing: false,
    dealer: null,
  }),
  computed: {
    ...mapState(['user']),
  },
  created() {
    if (!this.user) {
      this.$router.push('/sign-in');
    }
    this.name = this.user.name;
    this.phone = this.user.phone;

    if (this.user.URCode) {
      this.URCode = this.user.URCode;
      this.getDealer();
    }
  },
  methods: {
    validateForm() {
      Object.assign(this.$data.validation, this.$options.data().validation);

      let isFormValid = true;

      if (!this.name) {
        this.validation.name.error = 'Необходимо заполнить поле';
        this.validation.name.state = false;
        isFormValid = false;
      }

      if (this.password && this.password.length < 12) {
        this.validation.password.error = 'Длина пароля менее 12 символов';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (this.password && !this.confirmPassword) {
        this.validation.confirmPassword.error = 'Необходимо заполнить поле';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      if (this.password !== this.confirmPassword) {
        this.validation.confirmPassword.error = 'Пароль и подтверждение не совпадают';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      return isFormValid;
    },

    async editUser() {
      if (this.validateForm()) {
        this.processing = true;
        let user;

        const requestObject = {
          name: this.name,
          phone: this.phone,
        };

        if (this.password) {
          requestObject.password = this.password;
        }

        try {
          user = await this.$http.post(`users/1.0/users/${this.user.id}`, requestObject);
          this.password = '';
          this.confirmPassword = '';
        } finally {
          this.processing = false;
        }

        this.$store.commit('setUser', {
          ...this.user,
          name: user.name,
          phone: user.phone,
        });
      }
    },
    async getDealer() {
      this.dealer = await this.$http.get(`dealers/1.0/dealers/${this.URCode}`);
    },
    async editDealer() {
      this.processing = true;
      try {
        this.dealer = await this.$http.patch(`dealers/1.0/dealers/${this.URCode}`, {
          email: this.dealer.email,
          phone: this.dealer.phone,
        });
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<style lang="scss">
main {
  min-height: calc(100vh - 150px);

  .top-block {
    display: flex;
    justify-content: space-between;
    margin: 40px 0;

    &__title__text {
      color: var(--ford-gray-shadow);
      font-family: 'ArialNew-bold', sans-serif;
      line-height: initial;
      margin-bottom: 0;
    }
  }

  .profile-form {
    max-width: 535px;

    .form-group:not(:last-of-type) {
      margin-bottom: 20px;
    }

    label {
      color: var(--ford-gray-shadow);
      line-height: 18px;
    }
  }
}
</style>
